/* eslint-disable no-param-reassign */
/* eslint:disable */
import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';

class WebimState {
  accessScriptError = false;

  setup = {
    accountName: 'wwwmarathonbetru',
    domain: 'chat.marathonbet.ru',
  };
}

class WebimGetters extends Getters<WebimState> {
  get isAllowed() {
    return !this.state.accessScriptError;
  }

  get setup() {
    return this.state.setup;
  }
}

class WebimMutations extends Mutations<WebimState> {
  updateAccessScriptError(state: boolean) {
    this.state.accessScriptError = state;
  }
}

class WebimActions extends Actions<
  WebimState,
  WebimGetters,
  WebimMutations,
  WebimActions
  > {
}

// Экспорт модуля
export const WebimModule = new Module({
  state: WebimState,
  getters: WebimGetters,
  mutations: WebimMutations,
  actions: WebimActions,
});

export const WebimModuleMapper = createMapper(WebimModule);
